export default __webpack_public_path__ + "text-extractf43b55.png";